import React, {useState} from 'react'
import FJApplyLoading from "../../../common/component/FJApplyLoading";
import styles from "./FJFilterApply.module.less";
import FJLocalStore from "../../../store/FJLocalStore";

function FJFilterApply(props) {

  const {applyToAll} = props;
  const [loading, updateLoading] = useState(false);
  const handleApplyToAll = () => {
    updateLoading(true);
    applyToAll();
    setTimeout(() => {
      updateLoading(false);
    }, 2100);
  };

  return loading ? <FJApplyLoading /> :
        <span onClick={handleApplyToAll} className={styles.apply_name}>{FJLocalStore._('apply-filter')}</span>;
}

export default FJFilterApply;